import { Link } from 'foundations-components/transitional/components/Link';
import { getFullUrl } from 'hubspot-url-utils';
import { jsx as _jsx } from "react/jsx-runtime";
const FileLink = ({
  fileReference,
  portalId
}) => /*#__PURE__*/_jsx(Link, {
  external: true,
  href: `${getFullUrl('app')}/file-preview/${encodeURIComponent(portalId)}/file/${encodeURIComponent(fileReference.additionalProperties.fileId)}/`,
  children: fileReference.label
});
export default FileLink;